/** Existing shell services, isolated from the database architecture entry. No authority switch. */
/* ---------- shell 层通用 repo：邮件仍走本地 mock；场景/会话预置走后端，不再 import scenes.js ---------- */
import { mailList, mailPatch, mailMove, mailRemove, mailSend, mailSaveDraft, MAIL_ME, type MailMessage, type MailDraftInput, type MailFolder } from '../mock/mail'
import { apiGet } from './http-client'
import { orgRepo } from './org-repository'

export { orgRepo }

/**
 * 场景卡片与演示会话预置：走后端 /api/orgs/:id/scenes 与 /api/orgs/:id/chats。
 * 真实组织返回空对象/空数组；演示组织返回轻量预置（不携带 architecture-collections.json）。
 */
export const sceneRepo = {
  scenes(): Promise<Record<string, any>> {
    const id = orgRepo.id()
    return id ? apiGet<Record<string, any>>(`/api/orgs/${encodeURIComponent(id)}/scenes`) : Promise.resolve({})
  },
  chats(): Promise<any[]> {
    const id = orgRepo.id()
    return id ? apiGet<any[]>(`/api/orgs/${encodeURIComponent(id)}/chats`) : Promise.resolve([])
  }
}

export { directoryRepo } from './directory-repository'

export { menuRepo } from './menu-repository'

export {notifyRepo} from './notify-repository'

/**
 * 演示回答器：点击预置会话 / 场景 chips 时才动态 import scenes.js（含 19.7MB 架构集合）。
 * 与 sceneRepo 分离——sceneRepo 是首屏轻量路径，answerRepo 是按需重量路径。
 */
export const answerRepo = {
  answer(key: string): Promise<any> { return import('../mock/scenes.js').then(m => (m.ANSWERS as any)[key]) },
  domAnswer: (c: string) => import('../mock/scenes.js').then(m => m.domAnswer(c)),
  epAnswer: (c: string) => import('../mock/scenes.js').then(m => m.epAnswer(c)),
  ndAnswer: (c: string) => import('../mock/scenes.js').then(m => m.ndAnswer(c)),
  rpAnswer: (c: string) => import('../mock/scenes.js').then(m => m.rpAnswer(c))
}

export const mailRepo = {
  me: (): Promise<typeof MAIL_ME> => Promise.resolve(MAIL_ME),
  list: (): Promise<MailMessage[]> => Promise.resolve(mailList()),
  setFlag: (id: string, patch: Partial<Pick<MailMessage, 'unread' | 'starred'>>): Promise<void> => { mailPatch(id, patch); return Promise.resolve() },
  move: (id: string, folder: MailFolder): Promise<void> => { mailMove(id, folder); return Promise.resolve() },
  remove: (id: string): Promise<void> => { mailRemove(id); return Promise.resolve() },
  send: (input: MailDraftInput): Promise<MailMessage> => Promise.resolve(mailSend(input)),
  saveDraft: (input: MailDraftInput, id?: string): Promise<MailMessage> => Promise.resolve(mailSaveDraft(input, id))
}

export { sysConfigRepo } from './sys-config-repository'

export { discussionRepo } from './discussion-repository'
